<template>
    <div :class="`contentElement__${side}Icon`">
        <svg
            :class="`contentElement__${side}IconSvg`"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 29.22 32.47"
        >
            <path
                id="Path_1428"
                :class="`contentElement__${side}IconPath`"
                d="M22.73,24.35H6.49V19.48L0,26l6.49,6.5V27.6H26V17.86H22.73Z"
            />
            <path
                id="Path_1429"
                :class="`contentElement__${side}IconPath`"
                d="M6.49,8.12H22.73V13l6.49-6.5L22.73,0V4.87H3.25v9.74H6.49Z"
            />
        </svg>
    </div>
</template>

<script>
export default {

    props: {
        side: {
            type: String,
            default: 'front',
        },
    },

}
</script>
